import { Component, OnInit, Input } from '@angular/core';
import { DataIoService } from '../../../../../services/data-io.service';

@Component({
	selector: 'iconbar',
	templateUrl: './iconbar.component.html',
	styleUrls: ['./iconbar.component.scss']
})

export class IconbarComponent implements OnInit {
	@Input('debug') debug: boolean = true;
	@Input('classes') classes: string = "";

	constructor(private ioService: DataIoService) {

	}

	greenIq() {
		return this.ioService.getConfiguration().simulatorConfig.has('greeniq') && this.ioService.deviceInfo().getRawValue('greeniq') == 'ENUM_GREEN_IQ_ON';
	}

	getHeatingClass(): string {
		return 'iconHeatingGrey';
	}
	getDHWClass(): string {
		return 'iconDomesticWaterGrey';
	}
	getH2Class(){
		return 'iconH2';
	}
	hasH2(){
		console.log(`gastype: "${this.ioService.getConfiguration().simulatorConfig.gastype()}"` );
		return this.ioService.getConfiguration().simulatorConfig.gastype() == 'wasserstoff';
	}
	hasDHW() {
		let s = this.ioService.deviceInfo().getScale('d006');
		if (!this.ioService) {
			console.log("ioService null");
		}
		if (!this.ioService.deviceInfo()) {
			console.log("deviceInfo null");
		}
		if (!s) {
			console.log("scale 006 null");
		}
		let dis = (this.ioService.deviceInfo().getRawValue('ai_mode_dhw') == 'OFF' || this.ioService.deviceInfo().getRawValue('ai_mode') == 'heating' || s.getCurrentValue() <= 29);
		return !dis;
	}
	getPressureClass(): string {
		return 'iconPressureScale3Grey';
	}

	getBurnerClass(): string {
		return 'iconBurnerGrey';
	}

	hasBurner() {
		return this.ioService.deviceInfo().burnerActive();
	}

	hasWaterPressure() {
		return true;
	}
	hasHeating() {
		let s = this.ioService.deviceInfo().getHeatingCircuitById(1).getScale('vorlaufsolltemp');
		let dis = (this.ioService.deviceInfo().getRawValue('ai_mode_dhw') == 'OFF' || s.getCurrentValue() == 29);
		return !dis;
	}

	timerActive() {
		let mainZone = this.ioService.deviceInfo().getDefaultZoneId();
		let sc = this.ioService.getConfiguration().simulatorConfig;
		if (sc.isStandalone() || sc.witterungsgefuehrt() || sc.hasControl()) {
			return false;
		}
		if (sc.isStandalone()) {
			this.ioService.deviceInfo().getZoneById(mainZone).getRawValue('schaltuhr') == 'AICI_ON_NORMAL';
		}
		return this.ioService.deviceInfo().getZoneById(mainZone).getRawValue('heatingmode') == "ENUM_HEATING_MODE_TIMECONTROLLED";
	}
	hasBattery() {
		return this.ioService.getConfiguration().simulatorConfig.hasBattery();
	}
	hasRadio() {
		return this.ioService.getConfiguration().simulatorConfig.hasRadio();
	}
	isLocked() {
		return this.ioService.getDeviceInfo().getValue('buttonlock') == "on";
	}
	serviceDateExpired() {
		return this.ioService.serviceDateExpired();
	}
	comfortModeActive() {
		return (this.ioService.deviceInfo().getRawValue('comfortmode') == 'ENUM_GREEN_IQ_ON');
	}
	ngOnInit() {
	}

}
